var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _g, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYourTrusted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 569,
    height: 431,
    viewBox: "0 0 569 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 25H301V29H320V25Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320 70H301V74H320V70Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320 116H301V120H320V116Z",
    fill: "#BCC3CA"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M283 0V220L253 213.331V20.8891L283 0Z",
    fill: "#BCC3CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M375 1H282V221H375V1Z",
    fill: "#EAEEF3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M317 27H299V61H317V27Z",
    fill: "#BCC3CA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M343 27H324V61H343V27Z",
    fill: "#BCC3CA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M368 27H350V61H368V27Z",
    fill: "#BCC3CA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M317 72H299V106H317V72Z",
    fill: "#BCC3CA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M343 72H324V106H343V72Z",
    fill: "#BCC3CA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M368 72H350V106H368V72Z",
    fill: "#BCC3CA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M317 118H299V152H317V118Z",
    fill: "#BCC3CA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M343 118H324V152H343V118Z",
    fill: "#BCC3CA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M368 118H350V152H368V118Z",
    fill: "#BCC3CA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M317 163H299V197H317V163Z",
    fill: "#BCC3CA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M343 163H324V197H343V163Z",
    fill: "#BCC3CA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M368 163H350V197H368V163Z",
    fill: "#BCC3CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M317 27H299V31H317V27Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M317 72H299V76H317V72Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M317 118H299V122H317V118Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M317 163H299V167H317V163Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M375.996 217.351V221H282.795L253 214.315V181.67C254.993 174.708 257.4 167.93 260.257 162.332C271.209 140.855 267.64 132.124 269.932 116.41C272.224 100.696 267.133 15.4939 282.795 1C297.435 25.269 296.42 24.2212 296.928 50.0655C297.197 63.8884 297.179 76.1144 299.601 85.1933C301.702 93.0809 305.649 98.5856 313.226 100.699C314.82 101.144 316.393 101.851 317.936 102.799C322.865 105.809 327.496 111.253 331.425 118.333C336.588 127.631 340.549 139.753 342.395 152.905C342.902 156.504 343.251 160.186 343.42 163.903C343.478 165.138 343.518 166.387 343.532 167.632C343.546 168.716 343.546 169.799 343.532 170.883C343.525 171.267 343.525 171.644 343.532 172.013C343.604 181.412 346.432 187.889 350.408 192.859C352.092 194.965 353.984 196.799 355.963 198.468C363.868 205.142 373.132 209.169 376 217.34L375.996 217.351Z",
    fill: "#BCC3CA"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M196 21V183L170 178.093V36.385L193.645 22.3954L195.701 21.1758L196 21Z",
    fill: "#BCC3CA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M268 20H196V182H268V20Z",
    fill: "#F4F7FA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M219 38H210V171H219V38Z",
    fill: "#BCC3CA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M239 38H229V171H239V38Z",
    fill: "#BCC3CA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M258 38H248V171H258V38Z",
    fill: "#BCC3CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M219 38H216V171H219V38Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M238 38H235V171H238V38Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M258 38H255V171H258V38Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M268 181.989V182H195.93L170 177.098V160.631C182.011 142.294 178.057 134.668 180.65 121.065C183.182 107.784 177.841 37.8141 193.58 21.5517C194.148 20.9568 194.744 20.4408 195.369 20C195.455 20.1111 195.545 20.2222 195.631 20.3333C195.732 20.4587 195.829 20.5841 195.93 20.7095C204.119 31.102 207.872 36.0617 209.658 41.3403C211.396 46.4792 211.267 51.9155 211.551 62.9673C211.903 76.5563 211.831 88.3786 215.76 96.5169C216.583 98.2335 217.588 99.7816 218.81 101.151C221.184 103.817 224.388 105.791 228.723 106.949C229.204 107.078 229.697 107.2 230.203 107.307C231.891 107.665 233.561 108.225 235.206 108.966C236.237 109.425 237.254 109.959 238.256 110.561C241.621 112.568 244.836 115.324 247.789 118.674C250.281 121.502 252.591 124.752 254.653 128.325C255.594 129.959 256.488 131.661 257.321 133.428C257.451 133.7 257.576 133.969 257.702 134.245C262.368 144.419 265.137 156.485 264.893 168.769C264.785 174.116 265.978 178.42 267.996 181.989H268Z",
    fill: "#BCC3CA"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M270 149H116V219H270V149Z",
    fill: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M241.006 194.642C229.432 191.112 215.542 192.879 206.281 187.582C177.814 175.182 148.128 151.9 116 150V220H270V213.137C260.661 206.228 251.493 199.304 241.01 194.642H241.006Z",
    fill: "#BCC3CA"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M117 220L91 212.905V158.741L116.355 150L117 220Z",
    fill: "#BCC3CA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M253 191H221V220H253V191Z",
    fill: "#BCC3CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M253 191H250V220H253V191Z",
    fill: "#BCC3CA"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M194 191H162V220H194V191Z",
    fill: "#BCC3CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M193 191H190V220H193V191Z",
    fill: "#BCC3CA"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M464 221L326 196.745L333.605 120H441.908L464 221Z",
    fill: "#DEE1E7"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M415.282 169.393C393.943 153.623 365.377 159.263 355.78 140.358C352.673 134.235 352.408 127.219 353.854 120H333.618L326 196.946L440 217C435.826 191.413 426.075 177.368 415.286 169.393H415.282Z",
    fill: "#848484"
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M393 110H391V122H393V110Z",
    fill: "#51566D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M401 110H399V122H401V110Z",
    fill: "#51566D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M409 110H407V122H409V110Z",
    fill: "#51566D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M418 110H416V122H418V110Z",
    fill: "#51566D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M434 110H432V122H434V110Z",
    fill: "#51566D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M426 110H424V122H426V110Z",
    fill: "#51566D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M442 110H440V122H442V110Z",
    fill: "#51566D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M450 109H325V112H450V109Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M327 110H325V122H327V110Z",
    fill: "url(#paint0_linear_1720_115407)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M336 110H334V122H336V110Z",
    fill: "url(#paint1_linear_1720_115407)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M344 110H342V122H344V110Z",
    fill: "url(#paint2_linear_1720_115407)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M352 110H350V122H352V110Z",
    fill: "url(#paint3_linear_1720_115407)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M360 110H358V122H360V110Z",
    fill: "url(#paint4_linear_1720_115407)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M368 110H366V122H368V110Z",
    fill: "url(#paint5_linear_1720_115407)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M377 110H375V122H377V110Z",
    fill: "url(#paint6_linear_1720_115407)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M385 110H383V122H385V110Z",
    fill: "url(#paint7_linear_1720_115407)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M450 117H325V128H450V117Z",
    fill: "#2A374E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M404 153H291V208H404V153Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M400 157H296V205H400V157Z",
    fill: "#D8DEE8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M308 157H303V205H308V157Z",
    fill: "#D8DEE8"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M308 157H305V205H308V157Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M320 157H315V205H320V157Z",
    fill: "#D8DEE8"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M320 157H317V205H320V157Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M332 157H327V205H332V157Z",
    fill: "#D8DEE8"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M332 157H329V205H332V157Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M344 157H339V205H344V157Z",
    fill: "#D8DEE8"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M344 157H341V205H344V157Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M357 157H352V205H357V157Z",
    fill: "#D8DEE8"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M356 157H353V205H356V157Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M369 157H364V205H369V157Z",
    fill: "#D8DEE8"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M369 157H366V205H369V157Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M381 157H376V205H381V157Z",
    fill: "#D8DEE8"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M381 157H378V205H381V157Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M393 157H388V205H393V157Z",
    fill: "#D8DEE8"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M393 157H390V205H393V157Z",
    fill: "#D8DEE8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M292 153H235V208H292V153Z",
    fill: "#D8DEE8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M290 207V155H237V207H290Z",
    fill: "#D8DEE8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M289 156H264V205H289V156Z",
    fill: "#D8DEE8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M262 156H237V205H262V156Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M262 170H237V174H262V170Z",
    fill: "#D8DEE8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M262 187H237V191H262V187Z",
    fill: "#D8DEE8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M289 170H264V174H289V170Z",
    fill: "#D8DEE8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M289 187H264V191H289V187Z",
    fill: "#D8DEE8"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M250 155H249V207H250V155Z",
    fill: "#D8DEE8"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M249 207V155H250L249 207Z",
    fill: "#BCC3CA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M250 154H248V157H250V154Z",
    fill: "#D8DEE8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M250 205H248V208H250V205Z",
    fill: "#D8DEE8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M268 155H267V207H268V155Z",
    fill: "#D8DEE8"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M267 207V155H268L267 207Z",
    fill: "#BCC3CA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M269 154H267V157H269V154Z",
    fill: "#D8DEE8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M269 205H267V208H269V205Z",
    fill: "#D8DEE8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M277 155H276V207H277V155Z",
    fill: "#D8DEE8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M276 207V155H277L276 207Z",
    fill: "#BCC3CA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M278 154H276V157H278V154Z",
    fill: "#D8DEE8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M278 205H276V208H278V205Z",
    fill: "#D8DEE8"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M259 155H258V207H259V155Z",
    fill: "#D8DEE8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M258 207V155H259L258 207Z",
    fill: "#BCC3CA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M259 154H257V157H259V154Z",
    fill: "#D8DEE8"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M259 205H257V208H259V205Z",
    fill: "#D8DEE8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M386 99H273V154H386V99Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M381 102H277V150H381V102Z",
    fill: "#D8DEE8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M289 102H284V150H289V102Z",
    fill: "#D8DEE8"
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M289 102H286V150H289V102Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M301 102H296V150H301V102Z",
    fill: "#D8DEE8"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M301 102H298V150H301V102Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M313 102H308V150H313V102Z",
    fill: "#D8DEE8"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M313 102H310V150H313V102Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M326 102H321V150H326V102Z",
    fill: "#D8DEE8"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M325 102H322V150H325V102Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M338 102H333V150H338V102Z",
    fill: "#D8DEE8"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M338 102H335V150H338V102Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M350 102H345V150H350V102Z",
    fill: "#D8DEE8"
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M350 102H347V150H350V102Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M362 102H357V150H362V102Z",
    fill: "#D8DEE8"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M362 102H359V150H362V102Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M375 102H370V150H375V102Z",
    fill: "#D8DEE8"
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M374 102H371V150H374V102Z",
    fill: "#D8DEE8"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M273 99H216V154H273V99Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M271 152V100H218V152H271Z",
    fill: "#D8DEE8"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M270 101H245V150H270V101Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M243 101H218V150H243V101Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M243 115H218V119H243V115Z",
    fill: "#D8DEE8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M243 132H218V136H243V132Z",
    fill: "#D8DEE8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M270 115H245V119H270V115Z",
    fill: "#D8DEE8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M270 132H245V136H270V132Z",
    fill: "#D8DEE8"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M231 100H230V152H231V100Z",
    fill: "#D8DEE8"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M230 152V100H231L230 152Z",
    fill: "#BCC3CA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M231 99H229V102H231V99Z",
    fill: "#D8DEE8"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M231 150H229V153H231V150Z",
    fill: "#D8DEE8"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M249 100H248V152H249V100Z",
    fill: "#D8DEE8"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M248 152V100H249L248 152Z",
    fill: "#BCC3CA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M250 99H248V102H250V99Z",
    fill: "#D8DEE8"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M250 150H248V153H250V150Z",
    fill: "#D8DEE8"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M258 100H257V152H258V100Z",
    fill: "#D8DEE8"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M257 152V100H258L257 152Z",
    fill: "#BCC3CA"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M259 99H257V102H259V99Z",
    fill: "#D8DEE8"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M259 150H257V153H259V150Z",
    fill: "#D8DEE8"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M240 100H239V152H240V100Z",
    fill: "#D8DEE8"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M239 152V100H240L239 152Z",
    fill: "#BCC3CA"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M241 99H239V102H241V99Z",
    fill: "#D8DEE8"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M241 150H239V153H241V150Z",
    fill: "#D8DEE8"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M476.65 318H409.214C406.935 318 404.997 319.416 404.229 321.413H282.35C279.401 321.413 277 323.797 277 326.726V332.922C277 335.851 279.389 338.235 282.35 338.235C282.35 338.235 406.252 364 409.214 364H476.65C479.599 364 482 361.616 482 358.687V323.313C482 320.384 479.611 318 476.65 318Z",
    fill: "#30315D"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M408.341 318H475.659C478.603 318 481 320.384 481 323.313V358.687C481 361.616 478.603 364 475.659 364H408.341C405.397 364 403 361.616 403 358.687V323.313C403 320.384 405.397 318 408.341 318Z",
    fill: "url(#paint8_linear_1720_115407)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M506.657 209H426.59C426.079 209 425.592 209.097 425.118 209.231L268.343 233.871C265.398 233.871 263 236.255 263 239.212V320.553C263 323.497 265.385 325.894 268.343 325.894L426.59 333H506.657C509.602 333 512 330.615 512 327.658V214.354C512 211.409 509.615 209.012 506.657 209.012V209Z",
    fill: "#4371BC"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M272.833 233L268.342 233.707C265.397 233.707 263 236.096 263 239.059V320.553C263 323.503 265.385 325.905 268.342 325.905L426 333C343.064 310.581 292.73 257.832 272.833 233Z",
    fill: "#438AFE"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M427.357 209H507.643C510.596 209 513 211.397 513 214.342V327.658C513 330.603 510.596 333 507.643 333H427.357C424.404 333 422 330.603 422 327.658V214.342C422 211.397 424.404 209 427.357 209Z",
    fill: "#438AFE"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M551.605 246.335C551.605 243.394 549.211 241 546.242 241H436.363C433.407 241 431 243.394 431 246.335V327.917C431 330.858 433.395 333.252 436.363 333.252H485.463V354.665C485.463 357.606 487.857 360 490.826 360H555.637C558.593 360 561 357.618 561 354.665V304.705C561 301.752 551.593 246.335 551.593 246.335H551.605Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M475 333H436.352C433.402 333 431 330.625 431 327.68V246.321C431 243.388 433.39 241 436.352 241H475V333Z",
    fill: "#DAE4FF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M503.333 313H549.667C552.607 313 555 315.416 555 318.384V353.616C555 356.584 552.607 359 549.667 359H503.333C500.393 359 498 356.584 498 353.616V318.384C498 315.416 500.393 313 503.333 313Z",
    fill: "#8F9397"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.114 317H501.886C501.401 317 501 316.548 501 316C501 315.452 501.401 315 501.886 315H552.114C552.599 315 553 315.452 553 316C553 316.548 552.599 317 552.114 317Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.114 322H501.886C501.401 322 501 321.548 501 321C501 320.452 501.401 320 501.886 320H552.114C552.599 320 553 320.452 553 321C553 321.548 552.599 322 552.114 322Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.114 327H501.886C501.401 327 501 326.548 501 326C501 325.452 501.401 325 501.886 325H552.114C552.599 325 553 325.452 553 326C553 326.548 552.599 327 552.114 327Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.114 331H501.886C501.401 331 501 330.548 501 330C501 329.452 501.401 329 501.886 329H552.114C552.599 329 553 329.452 553 330C553 330.548 552.599 331 552.114 331Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.114 336H501.886C501.401 336 501 335.548 501 335C501 334.452 501.401 334 501.886 334H552.114C552.599 334 553 334.452 553 335C553 335.548 552.599 336 552.114 336Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.114 341H501.886C501.401 341 501 340.548 501 340C501 339.452 501.401 339 501.886 339H552.114C552.599 339 553 339.452 553 340C553 340.548 552.599 341 552.114 341Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.114 346H501.886C501.401 346 501 345.548 501 345C501 344.452 501.401 344 501.886 344H552.114C552.599 344 553 344.452 553 345C553 345.548 552.599 346 552.114 346Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.114 350H501.886C501.401 350 501 349.548 501 349C501 348.452 501.401 348 501.886 348H552.114C552.599 348 553 348.452 553 349C553 349.548 552.599 350 552.114 350Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.114 355H501.886C501.401 355 501 354.548 501 354C501 353.452 501.401 353 501.886 353H552.114C552.599 353 553 353.452 553 354C553 354.548 552.599 355 552.114 355Z",
    fill: "#DBDBDB"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M560.63 330H556.871C553.906 330 551.514 332.408 551.514 335.393V356.78H501.598V335.393C501.598 332.42 499.206 330 496.241 330H473.358C470.404 330 468 332.408 468 335.393V366.607C468 369.58 470.392 372 473.358 372H560.642C563.596 372 566 369.58 566 366.607V335.393C566 332.42 563.608 330 560.642 330H560.63Z",
    fill: "#97A6B7"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M490.568 366.607V335.393C490.568 332.42 492.993 330 496 330H473.432C470.437 330 468 332.408 468 335.393V366.607C468 369.58 470.425 372 473.432 372H496C493.006 372 490.568 369.58 490.568 366.607Z",
    fill: "#8B9AAC"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M487.434 348H490.566C493.561 348 496 350.379 496 353.301V358.699C496 361.621 493.561 364 490.566 364H487.434C484.439 364 482 361.621 482 358.699V353.301C482 350.379 484.439 348 487.434 348Z",
    fill: "#ECC711"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M560.434 348H563.566C566.561 348 569 350.379 569 353.301V358.699C569 361.621 566.561 364 563.566 364H560.434C557.439 364 555 361.621 555 358.699V353.301C555 350.379 557.439 348 560.434 348Z",
    fill: "#ECC711"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M482.329 265C479.391 265 477 267.388 477 270.35V292.65C477 295.599 479.379 298 482.329 298H559C557.774 289.884 555.54 276.236 553.683 265H482.329Z",
    fill: "#475B66"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M482.329 265C479.391 265 477 267.388 477 270.35V292.65C477 295.599 479.379 298 482.329 298H559L482.329 265Z",
    fill: "#161616"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M450.288 339H444.712C439.897 339 436 347.279 436 357.5C436 367.721 439.897 376 444.712 376H450.288C455.103 376 459 367.721 459 357.5C459 347.279 455.103 339 450.288 339Z",
    fill: "#6C6E99"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M453 357.5C453 367.721 449.198 376 444.5 376C439.802 376 436 367.721 436 357.5C436 347.279 439.802 339 444.5 339C449.198 339 453 347.279 453 357.5Z",
    fill: "#4F5D83"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M448 358C448 362.971 446.206 367 444 367C441.794 367 440 362.971 440 358C440 353.029 441.794 349 444 349C446.206 349 448 353.029 448 358Z",
    fill: "#E9EDF3"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M389.421 334H384.579C380.391 334 377 341.386 377 350.5C377 359.614 380.391 367 384.579 367H389.421C393.609 367 397 359.614 397 350.5C397 341.386 393.609 334 389.421 334Z",
    fill: "#6C6E99"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M393 350.5C393 359.614 389.421 367 385 367C380.579 367 377 359.614 377 350.5C377 341.386 380.579 334 385 334C389.421 334 393 341.386 393 350.5Z",
    fill: "#4F5D83"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M389 350C389 354.418 387.432 358 385.494 358C383.557 358 382 354.418 382 350C382 345.582 383.568 342 385.494 342C387.42 342 389 345.582 389 350Z",
    fill: "#E9EDF3"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M321.693 334H318.307C315.376 334 313 338.922 313 345C313 351.078 315.376 356 318.307 356H321.693C324.624 356 327 351.078 327 345C327 338.922 324.624 334 321.693 334Z",
    fill: "#6C6E99"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M318.5 356C321.538 356 324 351.075 324 345C324 338.925 321.538 334 318.5 334C315.462 334 313 338.925 313 345C313 351.075 315.462 356 318.5 356Z",
    fill: "#4F5D83"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M321 344.5C321 347.544 319.878 350 318.5 350C317.122 350 316 347.532 316 344.5C316 341.468 317.122 339 318.5 339C319.878 339 321 341.468 321 344.5Z",
    fill: "#E9EDF3"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M306.076 332H302.924C300.211 332 298 336.703 298 342.5C298 348.297 300.199 353 302.924 353H306.076C308.801 353 311 348.297 311 342.5C311 336.703 308.801 332 306.076 332Z",
    fill: "#6C6E99"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M308 342.5C308 348.297 305.767 353 303 353C300.233 353 298 348.297 298 342.5C298 336.703 300.233 332 303 332C305.767 332 308 336.703 308 342.5Z",
    fill: "#4F5D83"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M305 342.006C305 344.764 303.88 347 302.5 347C301.12 347 300 344.764 300 342.006C300 339.248 301.12 337 302.5 337C303.88 337 305 339.236 305 342.006Z",
    fill: "#E9EDF3"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M291.832 330H289.168C286.87 330 285 334.026 285 339C285 343.974 286.87 348 289.168 348H291.832C294.13 348 296 343.962 296 339C296 334.038 294.13 330 291.832 330Z",
    fill: "#6C6E99"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M293 340C293 344.974 291.205 349 289 349C286.795 349 285 344.962 285 340C285 335.038 286.795 331 289 331C291.205 331 293 335.026 293 340Z",
    fill: "#4F5D83"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M292 339.006C292 341.209 291.102 343 289.994 343C288.886 343 288 341.209 288 339.006C288 336.802 288.898 335 289.994 335C291.089 335 292 336.791 292 339.006Z",
    fill: "#E9EDF3"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M506 390.3L4 386V398.725C4 402.18 6.19037 405.115 9.15392 405.639L151.105 430.697C152.789 430.993 154.497 431.074 156.198 430.932L500.545 402.361C503.619 402.105 506 399.16 506 395.612V390.3Z",
    fill: "#BFC8D6"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M324.618 369.881L10.2003 392.973C4.57445 393.386 0 388.996 0 383.164V149.558C0 143.728 4.57445 139 10.2003 139H324.618C329.254 139 333 143.274 333 148.543V359.722C333 364.993 329.251 369.541 324.618 369.881Z",
    fill: "#BFC8D6"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M329.592 369.881L14.2309 392.973C8.58818 393.386 4 388.996 4 383.164V149.558C4 143.728 8.58818 139 14.2309 139H329.592C334.242 139 338 143.274 338 148.543V359.722C338 364.993 334.24 369.541 329.592 369.881Z",
    fill: "#30315D"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M319.084 354.877L26.2967 374.981C21.7191 375.295 18 371.684 18 366.913V161.935C18 157.164 21.7191 153.281 26.2967 153.262L319.084 152C322.908 151.984 326 155.492 326 159.839V346.538C326 350.882 322.908 354.618 319.084 354.881V354.877Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M341.384 368.07L4 392.648L151.105 418.696C152.789 418.993 154.497 419.074 156.198 418.931L506 389.82L346.749 368.236C344.969 367.994 343.172 367.938 341.382 368.068L341.384 368.07Z",
    fill: "url(#paint9_linear_1720_115407)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M54 393.837L334.262 373L421 384.727L143.153 407L54 393.837Z",
    fill: "#D8DEE8"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M145 366.796L25.6638 374.988C22.145 375.225 18 371.971 18 368.435V161.191C18 157.826 22.0338 153.014 25.3901 153H145V366.796Z",
    fill: "#D8DEE8"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M130 218.49L58 221V211.309L130 209V218.49Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M130 232.467L58 235V226.355L130 224V232.467Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M130 247.994L58 251V241.816L130 239V247.994Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M130 263.766L58 267V258.049L130 255V263.766Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M272.985 345.254L85.9489 357.958C76.2248 358.619 68.0369 351.477 68.0267 342.331L68 319.141C67.9898 310.654 75.0639 303.542 84.0865 302.965L271.125 291.037C280.82 290.42 288.961 297.549 288.973 306.67L289 329.085C289.01 337.545 281.981 344.645 272.987 345.254H272.985Z",
    fill: "#00C851"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M121.893 326.701C120.338 326.607 119.954 326.414 119.923 325.938C119.898 325.549 120.248 325.222 121.617 325.133C124.528 324.944 125.942 325.895 125.942 325.895L127.391 322.672C125.301 321.069 121.76 321.299 121.76 321.299C117.437 321.58 115.601 323.872 115.766 326.426C115.929 328.936 117.729 330.448 121.746 330.818C123.677 330.996 124.446 331.077 124.487 331.704C124.539 332.505 123.265 332.718 122.111 332.75C122.111 332.75 119.569 332.915 117.289 331.39L115.961 334.8C115.961 334.8 118.47 336.81 122.358 336.558C127.051 336.253 128.815 333.857 128.633 331.044C128.394 327.366 124.784 326.883 121.893 326.701Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M134.517 335.768C135.777 335.687 136.979 335.043 137.533 333.834L137.623 335.219L141.794 334.948L141.074 323.869L136.903 324.14L137.285 330.026C137.367 331.281 136.551 331.812 135.834 331.858C135.073 331.908 134.241 331.527 134.157 330.229L133.775 324.343L129.604 324.614L130.031 331.192C130.242 334.438 132.323 335.911 134.517 335.768Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M150.615 322.902C149.29 322.988 148.284 323.618 147.583 324.577L147.24 319.297L143.069 319.568L144.058 334.801L148.229 334.53L148.156 333.405C148.975 334.264 150.055 334.759 151.38 334.673C154.269 334.486 156.422 331.695 156.212 328.449C156.001 325.203 153.505 322.714 150.615 322.902ZM150.112 331.279C148.961 331.354 147.956 330.332 147.869 328.991C147.782 327.649 148.646 326.507 149.798 326.432C150.949 326.357 151.953 327.378 152.04 328.72C152.128 330.061 151.264 331.204 150.112 331.279Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M171.655 321.536C170.612 321.603 168.998 321.947 167.899 323.496C167.151 322.393 166.006 321.903 164.703 321.987C163.443 322.069 162.241 322.712 161.687 323.921L161.597 322.537L157.426 322.807L158.145 333.886L162.316 333.615L161.934 327.73C161.853 326.475 162.669 325.944 163.386 325.897C164.146 325.848 164.631 326.251 164.715 327.549L165.097 333.435L169.268 333.164L168.886 327.278C168.805 326.023 169.621 325.492 170.338 325.446C171.098 325.396 171.583 325.799 171.667 327.098L172.049 332.983L176.22 332.712L175.793 326.134C175.582 322.889 173.849 321.393 171.655 321.536Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M179.429 320.335C180.667 320.255 181.622 319.172 181.542 317.938C181.462 316.705 180.375 315.754 179.137 315.835C177.877 315.917 176.943 316.998 177.023 318.232C177.104 319.465 178.169 320.417 179.429 320.335ZM178.13 332.588L182.302 332.317L181.582 321.239L177.411 321.51L178.13 332.588Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M191.186 324.092L190.961 320.63L188.875 320.765L188.65 317.303L184.479 317.574L184.704 321.036L183.314 321.126L183.539 324.588L184.929 324.498L185.203 328.717C185.382 331.14 186.293 332.406 188.922 332.235C190.139 332.156 190.914 331.997 191.68 331.708L191.478 328.592C189.653 329.037 189.38 328.533 189.28 326.997L189.1 324.227L191.186 324.092Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M203.949 327.087L203.252 316.355L199.081 316.626L200.025 331.166L209.758 330.534L209.51 326.726L203.949 327.087Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M216.322 318.635C212.39 318.89 210.237 321.681 210.448 324.927C210.659 328.172 213.198 330.659 217.087 330.406C220.802 330.165 223.172 327.36 222.961 324.114C222.751 320.868 220.016 318.395 216.322 318.635ZM216.862 326.944C215.71 327.019 214.706 325.997 214.619 324.656C214.532 323.314 215.396 322.172 216.547 322.097C217.699 322.022 218.703 323.043 218.79 324.385C218.877 325.727 218.013 326.869 216.862 326.944Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M231.987 317.965L232.06 319.09C231.241 318.231 230.162 317.736 228.836 317.822C225.947 318.01 223.794 320.801 224.005 324.046C224.215 327.292 226.711 329.781 229.601 329.593C230.926 329.507 231.932 328.877 232.634 327.919L232.707 329.044L236.878 328.773L236.158 317.694L231.987 317.965ZM230.419 326.063C229.267 326.138 228.263 325.117 228.176 323.775C228.089 322.434 228.953 321.291 230.104 321.217C231.255 321.142 232.26 322.163 232.347 323.505C232.434 324.846 231.57 325.989 230.419 326.063Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M245.635 312.907L245.978 318.187C245.158 317.327 244.079 316.832 242.754 316.918C239.864 317.106 237.711 319.897 237.922 323.143C238.133 326.388 240.629 328.877 243.518 328.689C244.844 328.603 245.85 327.973 246.551 327.015L246.624 328.14L250.795 327.869L249.806 312.636L245.635 312.907ZM244.336 325.16C243.185 325.234 242.18 324.213 242.093 322.872C242.006 321.53 242.87 320.387 244.022 320.313C245.173 320.238 246.177 321.259 246.265 322.601C246.352 323.942 245.488 325.085 244.336 325.16Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M191.505 265.441C191.505 265.441 209.157 260.893 216.921 248.835C224.687 236.776 225.241 228.987 230.418 228.987C235.595 228.987 233.745 232.883 241.326 234.181C248.905 235.48 252.973 234.181 254.082 229.172C255.192 224.163 254.082 207.469 252.05 204.872C250.017 202.275 245.765 193.557 245.209 190.774C244.655 187.992 243.451 178 243.451 178L247.797 178.903C247.797 178.903 251.496 193.001 253.713 196.154C255.932 199.307 256.486 217.857 267.948 218.229C279.41 218.6 275.158 204.317 288.84 199.494C302.521 194.672 304 194.672 304 194.672V202.277C304 202.277 287.73 205.245 283.665 212.664C279.597 220.083 272.756 228.431 270.354 232.697C267.95 236.964 261.666 242.158 259.262 243.457C256.858 244.756 260.187 259.039 248.169 264.789C236.151 270.539 231.345 255.328 228.203 255.886C225.06 256.441 218.404 266.458 215.262 269.798C212.119 273.136 209.531 277.217 201.765 278.516C193.999 279.815 172 280 172 280V266.458L191.509 265.443L191.505 265.441Z",
    fill: "#D8DEE8"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M182.583 250.715C182.583 250.715 198.734 240.252 199.848 237.682C200.963 235.111 205.789 211.613 207.459 208.493C209.13 205.372 225.838 192.337 227.138 190.135C228.438 187.931 227.882 176 227.882 176H172V252L182.581 250.715H182.583Z",
    fill: "#D8DEE8"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M199.981 236C199.681 236 199.386 235.901 199.193 235.711C198.87 235.394 198.962 234.945 199.396 234.71C199.396 234.71 199.773 234.506 200.432 234.144C200.866 233.907 201.478 233.969 201.803 234.283C202.127 234.598 202.043 235.047 201.612 235.284C200.943 235.653 200.563 235.857 200.563 235.857C200.387 235.951 200.184 235.998 199.981 235.998V236Z",
    fill: "url(#paint10_linear_1720_115407)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M276.046 239C275.902 239 275.747 238.994 275.585 238.982C275.136 238.947 274.803 238.559 274.838 238.115C274.873 237.67 275.256 237.337 275.712 237.374C275.834 237.384 275.949 237.382 276.056 237.388C276.252 237.388 276.418 237.374 276.554 237.343C276.875 237.274 277.194 237.186 277.503 237.086C277.931 236.948 278.39 237.176 278.53 237.6C278.67 238.023 278.439 238.48 278.011 238.618C277.651 238.737 277.278 238.837 276.902 238.918C276.647 238.973 276.352 239 276.044 239H276.046ZM273.537 238.58C273.465 238.58 273.393 238.569 273.321 238.551C272.689 238.38 271.977 238.153 271.208 237.878C270.784 237.727 270.566 237.266 270.718 236.845C270.87 236.427 271.337 236.209 271.759 236.36C272.49 236.621 273.161 236.833 273.751 236.996C274.185 237.115 274.439 237.558 274.321 237.988C274.222 238.345 273.895 238.582 273.537 238.582V238.58ZM279.717 237.784C279.437 237.784 279.166 237.641 279.013 237.384C278.787 236.999 278.921 236.505 279.308 236.282C279.869 235.958 280.413 235.568 280.923 235.126C281.261 234.834 281.775 234.866 282.071 235.201C282.368 235.536 282.333 236.046 281.995 236.34C281.407 236.852 280.777 237.3 280.125 237.676C279.997 237.749 279.855 237.786 279.717 237.786V237.784ZM269.471 237.154C269.368 237.154 269.263 237.133 269.162 237.092C268.516 236.829 267.847 236.544 267.158 236.24C266.748 236.058 266.563 235.581 266.746 235.175C266.929 234.769 267.407 234.585 267.82 234.766C268.493 235.064 269.148 235.344 269.779 235.601C270.195 235.77 270.393 236.242 270.222 236.654C270.092 236.966 269.79 237.154 269.471 237.154ZM265.53 235.417C265.415 235.417 265.295 235.393 265.184 235.34C264.544 235.04 263.892 234.728 263.229 234.403C262.826 234.205 262.661 233.724 262.861 233.324C263.058 232.924 263.546 232.761 263.949 232.957C264.602 233.275 265.246 233.585 265.88 233.881C266.285 234.071 266.46 234.552 266.269 234.954C266.129 235.246 265.838 235.417 265.532 235.417H265.53ZM282.95 235.001C282.769 235.001 282.588 234.942 282.438 234.82C282.09 234.538 282.038 234.03 282.322 233.685C282.738 233.179 283.133 232.622 283.491 232.033C283.722 231.651 284.222 231.529 284.607 231.759C284.992 231.99 285.115 232.485 284.883 232.867C284.483 233.524 284.045 234.142 283.58 234.707C283.419 234.903 283.185 235.003 282.95 235.003V235.001ZM202.814 233.644C202.569 233.644 202.329 233.536 202.168 233.328C201.894 232.975 201.962 232.469 202.318 232.198C202.829 231.808 203.401 231.372 204.018 230.894C204.372 230.619 204.885 230.684 205.158 231.035C205.434 231.386 205.37 231.894 205.016 232.167C204.395 232.647 203.821 233.087 203.306 233.479C203.158 233.591 202.985 233.646 202.812 233.646L202.814 233.644ZM261.661 233.528C261.537 233.528 261.41 233.5 261.292 233.44C260.657 233.118 260.012 232.79 259.368 232.453C258.971 232.247 258.817 231.759 259.027 231.363C259.235 230.97 259.724 230.817 260.124 231.025C260.762 231.357 261.399 231.684 262.031 232.002C262.431 232.204 262.591 232.69 262.385 233.087C262.241 233.367 261.957 233.528 261.661 233.528ZM257.841 231.543C257.712 231.543 257.58 231.512 257.456 231.447C256.821 231.108 256.187 230.768 255.555 230.423C255.162 230.209 255.016 229.719 255.232 229.329C255.448 228.94 255.942 228.797 256.335 229.009C256.963 229.35 257.592 229.69 258.224 230.025C258.619 230.235 258.767 230.725 258.555 231.117C258.409 231.388 258.127 231.541 257.839 231.541L257.841 231.543ZM206.216 231.017C205.975 231.017 205.739 230.912 205.578 230.71C205.298 230.362 205.358 229.854 205.71 229.578C206.251 229.154 206.813 228.709 207.389 228.25C207.739 227.97 208.251 228.026 208.531 228.372C208.813 228.719 208.758 229.227 208.408 229.505C207.827 229.968 207.264 230.415 206.718 230.841C206.568 230.959 206.391 231.014 206.214 231.014L206.216 231.017ZM254.059 229.488C253.925 229.488 253.789 229.456 253.664 229.386C253.028 229.035 252.4 228.682 251.779 228.334C251.388 228.113 251.252 227.622 251.474 227.234C251.696 226.846 252.192 226.71 252.583 226.932C253.199 227.279 253.826 227.628 254.458 227.979C254.851 228.195 254.991 228.687 254.771 229.076C254.623 229.339 254.345 229.49 254.061 229.49L254.059 229.488ZM209.573 228.338C209.338 228.338 209.103 228.238 208.943 228.042C208.659 227.697 208.708 227.189 209.056 226.907C209.601 226.465 210.155 226.012 210.708 225.553C211.054 225.267 211.567 225.312 211.855 225.655C212.143 225.995 212.098 226.506 211.752 226.791C211.194 227.254 210.636 227.709 210.087 228.156C209.937 228.279 209.754 228.338 209.573 228.338ZM250.307 227.377C250.169 227.377 250.029 227.342 249.902 227.269C249.264 226.903 248.638 226.544 248.033 226.191C247.646 225.967 247.515 225.471 247.743 225.088C247.969 224.704 248.469 224.575 248.856 224.8C249.461 225.151 250.081 225.508 250.717 225.871C251.106 226.093 251.239 226.587 251.015 226.973C250.865 227.232 250.591 227.377 250.309 227.377H250.307ZM212.876 225.598C212.647 225.598 212.419 225.502 212.258 225.316C211.966 224.977 212.005 224.469 212.347 224.18C212.892 223.717 213.433 223.251 213.964 222.786C214.302 222.492 214.814 222.525 215.112 222.858C215.409 223.192 215.378 223.7 215.04 223.996C214.503 224.465 213.956 224.937 213.406 225.404C213.254 225.534 213.065 225.598 212.878 225.598H212.876ZM246.584 225.216C246.442 225.216 246.3 225.179 246.169 225.104C245.52 224.722 244.901 224.353 244.312 224C243.928 223.77 243.804 223.274 244.037 222.892C244.269 222.511 244.769 222.388 245.154 222.619C245.739 222.97 246.356 223.337 247 223.717C247.385 223.945 247.513 224.439 247.284 224.822C247.132 225.075 246.862 225.216 246.584 225.216ZM242.892 223C242.746 223 242.6 222.962 242.467 222.88C241.777 222.46 241.16 222.076 240.627 221.742C240.248 221.503 240.135 221.005 240.376 220.63C240.616 220.254 241.119 220.142 241.497 220.381C242.026 220.713 242.637 221.091 243.319 221.507C243.701 221.74 243.821 222.237 243.584 222.617C243.43 222.864 243.164 223 242.89 223H242.892ZM216.106 222.77C215.886 222.77 215.666 222.682 215.506 222.509C215.203 222.18 215.226 221.67 215.557 221.37C216.094 220.883 216.617 220.399 217.117 219.924C217.44 219.616 217.954 219.626 218.267 219.946C218.578 220.266 218.568 220.779 218.245 221.087C217.736 221.57 217.205 222.062 216.658 222.56C216.502 222.701 216.306 222.77 216.109 222.77H216.106ZM239.254 220.699C239.098 220.699 238.939 220.654 238.801 220.562C238.349 220.26 237.883 219.944 237.41 219.622L237.017 219.355C236.647 219.104 236.552 218.602 236.807 218.234C237.06 217.867 237.567 217.773 237.937 218.026L238.33 218.294C238.801 218.614 239.262 218.926 239.711 219.226C240.083 219.475 240.182 219.977 239.931 220.346C239.775 220.577 239.518 220.701 239.256 220.701L239.254 220.699ZM219.21 219.807C219.006 219.807 218.8 219.732 218.642 219.579C218.321 219.269 218.313 218.759 218.625 218.438C219.158 217.896 219.64 217.38 220.058 216.904C220.354 216.57 220.866 216.535 221.206 216.827C221.544 217.12 221.581 217.628 221.284 217.965C220.846 218.463 220.344 219.002 219.79 219.565C219.632 219.728 219.42 219.809 219.208 219.809L219.21 219.807ZM235.69 218.302C235.535 218.302 235.381 218.259 235.243 218.169C234.653 217.784 234.054 217.406 233.451 217.047C233.066 216.818 232.94 216.323 233.171 215.941C233.401 215.56 233.901 215.435 234.286 215.664C234.91 216.033 235.527 216.425 236.136 216.823C236.511 217.067 236.616 217.567 236.369 217.939C236.212 218.173 235.953 218.302 235.69 218.302ZM222.062 216.61C221.858 216.61 221.657 216.535 221.498 216.386C221.175 216.078 221.165 215.568 221.476 215.245C222.058 214.644 222.698 214.156 223.375 213.797C223.77 213.587 224.264 213.734 224.476 214.127C224.688 214.519 224.54 215.009 224.143 215.219C223.616 215.498 223.114 215.884 222.647 216.363C222.486 216.529 222.274 216.61 222.06 216.61H222.062ZM231.988 216.129C231.864 216.129 231.738 216.1 231.621 216.041C230.963 215.711 230.329 215.437 229.738 215.223C229.316 215.07 229.098 214.609 229.253 214.191C229.407 213.772 229.874 213.558 230.294 213.709C230.944 213.944 231.638 214.244 232.354 214.603C232.755 214.803 232.916 215.288 232.714 215.686C232.57 215.968 232.284 216.129 231.988 216.129ZM227.944 214.719C227.9 214.719 227.857 214.715 227.812 214.709C227.139 214.601 226.497 214.584 225.904 214.66C225.462 214.719 225.052 214.405 224.993 213.964C224.935 213.524 225.25 213.117 225.694 213.06C226.441 212.964 227.244 212.983 228.073 213.115C228.516 213.187 228.818 213.601 228.746 214.042C228.68 214.438 228.337 214.719 227.944 214.719Z",
    fill: "#30315D"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M284.21 231.998C284.047 231.998 283.885 231.972 283.726 231.92C283.113 231.717 282.835 231.171 283.101 230.703C283.465 230.066 283.634 229.656 283.634 229.651C283.833 229.164 284.51 228.89 285.147 229.042C285.784 229.194 286.142 229.712 285.946 230.199C285.937 230.22 285.741 230.703 285.318 231.445C285.119 231.792 284.675 232 284.21 232V231.998Z",
    fill: "url(#paint11_linear_1720_115407)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M220.998 190.924C220.998 200.294 208.128 217.388 202.304 224.646C200.853 226.451 198.145 226.451 196.694 224.646C190.87 217.39 178 200.294 178 190.924C178 178.815 187.625 169 199.5 169C211.375 169 221 178.815 221 190.924H220.998Z",
    fill: "#ECC711"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M204.275 201.581C210.399 199.046 213.306 192.028 210.769 185.905C208.231 179.782 201.211 176.874 195.087 179.41C188.964 181.945 186.057 188.963 188.594 195.086C191.131 201.208 198.152 204.116 204.275 201.581Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M199.559 215.596C200.932 206.394 206.907 203.447 205.883 194.758C204.7 184.736 195.976 182.068 195.765 173.148C195.731 171.711 195.924 170.327 196.287 169C185.926 170.647 178 179.761 178 190.761C178 200.172 190.963 217.348 196.83 224.64C197.691 225.709 198.989 226.147 200.21 225.957C199.159 221.927 199.129 218.483 199.559 215.596Z",
    fill: "url(#paint12_linear_1720_115407)"
  }))), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M199.5 239C201.985 239 204 236.985 204 234.5C204 232.015 201.985 230 199.5 230C197.015 230 195 232.015 195 234.5C195 236.985 197.015 239 199.5 239Z",
    fill: "#30315D"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M297 206.54C297 211.47 290.115 220.468 287.001 224.287C286.227 225.238 284.777 225.238 284.001 224.287C280.885 220.468 274 211.47 274 206.54C274 200.167 279.149 195 285.5 195C291.851 195 297 200.167 297 206.54Z",
    fill: "#ECC711"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M290.874 206.666C291.45 203.123 289.043 199.784 285.5 199.209C281.956 198.634 278.617 201.041 278.042 204.584C277.466 208.127 279.873 211.466 283.416 212.041C286.96 212.616 290.299 210.209 290.874 206.666Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M284.549 219.525C285.285 214.682 288.486 213.131 287.937 208.557C287.303 203.283 282.631 201.877 282.517 197.183C282.498 196.427 282.602 195.698 282.796 195C277.248 195.866 273 200.663 273 206.453C273 211.406 279.945 220.447 283.086 224.284C283.546 224.845 284.243 225.077 284.897 224.978C284.336 222.855 284.317 221.043 284.549 219.523V219.525Z",
    fill: "url(#paint13_linear_1720_115407)"
  }))), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M286.224 231.663C287.5 231.135 288.105 229.672 287.577 228.397C287.048 227.121 285.586 226.515 284.31 227.044C283.034 227.572 282.428 229.034 282.957 230.31C283.486 231.585 284.948 232.191 286.224 231.663Z",
    fill: "#30315D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.48
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1934 392.973L326.873 369.998L328.465 369.881C330.591 369.726 332.523 368.677 334 367.086C311.499 365.857 297.524 357.886 288.509 349.649C270.404 333.111 273.544 316.799 254.02 305.924C229.669 292.361 210.521 309.548 192.042 292.59C180.838 282.309 186.339 274.642 172.554 259.28C157.287 242.264 147.345 247.984 132.002 232.668C112.6 213.303 122.304 198.237 105.592 184.336C85.318 167.47 63.4542 183.081 44.1551 166.906C35.8319 159.929 31.2637 149.787 28.8793 139H14.1955C8.57229 139 4 143.728 4 149.558V383.164C4 388.994 8.57229 393.384 14.1955 392.973H14.1934Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1720_115407",
    x1: 326.002,
    y1: -168.656,
    x2: 326.002,
    y2: -168.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1720_115407",
    x1: 334.998,
    y1: -168.656,
    x2: 334.998,
    y2: -168.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1720_115407",
    x1: 342.998,
    y1: -168.656,
    x2: 342.998,
    y2: -168.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1720_115407",
    x1: 350.998,
    y1: -168.656,
    x2: 350.998,
    y2: -168.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1720_115407",
    x1: 358.998,
    y1: -168.656,
    x2: 358.998,
    y2: -168.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1720_115407",
    x1: 367.002,
    y1: -168.656,
    x2: 367.002,
    y2: -168.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1720_115407",
    x1: 376.002,
    y1: -168.656,
    x2: 376.002,
    y2: -168.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1720_115407",
    x1: 383.998,
    y1: -168.656,
    x2: 383.998,
    y2: -168.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1720_115407",
    x1: 425.5,
    y1: 320.5,
    x2: 442,
    y2: 364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51566D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393D74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1720_115407",
    x1: 4,
    y1: 393.5,
    x2: 506,
    y2: 393.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1720_115407",
    x1: 198.999,
    y1: 235.001,
    x2: 303.687,
    y2: 235.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1720_115407",
    x1: 156.591,
    y1: 230.499,
    x2: 286.002,
    y2: 230.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1720_115407",
    x1: 189.052,
    y1: 185.848,
    x2: 211.512,
    y2: 242.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1720_115407",
    x1: 278.92,
    y1: 203.869,
    x2: 290.591,
    y2: 233.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourTrusted);
export default __webpack_public_path__ + "static/media/your-trusted.a8ba06075a52bcfc1224a000fe6a2180.svg";
export { ForwardRef as ReactComponent };